export const QUESTION_TYPES = {
    SELECT: 'select',
    MULTI_SELECT: 'multiSelect',
    TEXT: 'text',
} as const;

export const SPECIAL_ANSWERS = {
    OTHER: 'other',
} as const;

export const TEXTAREA_ROWS = {
    OTHER_INPUT: 3,
    MAIN_TEXT: 6,
} as const;

export const INITIAL_QUESTION_ID = 'cancellation_reason';

export const ANALYTICS_EVENTS = {
    SURVEY_STARTED: 'cancellation-survey-started',
    SURVEY_COMPLETED: 'cancellation-survey-completed',
    SURVEY_SKIPPED: 'cancellation-survey-skipped',
} as const;

export const ANALYTICS_STEP_NAME = 'request connect stan team member';
